/** QuickPlan — Champ texte validé en quittant le champ (ou Entrée sur une ligne) :
 *  un seul cran d'historique par saisie. */
import { useState, useEffect } from 'react';

export default function TextField({ value, onCommit, multiline = false, max = 500, ...props }) {
  const [text, setText] = useState(value ?? '');
  useEffect(() => { setText(value ?? ''); }, [value]);
  const commit = () => { const v = text.slice(0, max); if (v !== (value ?? '')) onCommit(v); };
  const common = {
    value: text,
    onChange: (e) => setText(e.target.value),
    onBlur: commit,
    onKeyDown: (e) => {
      if (e.key === 'Enter' && !multiline) e.target.blur();
      if (e.key === 'Escape') { setText(value ?? ''); e.target.blur(); }
      e.stopPropagation();
    },
    ...props,
  };
  return multiline ? <textarea {...common} /> : <input {...common} />;
}
